import React from 'react'
import useQuery from 'apollo-hooks/lib/useApolloQuery'
import gql from 'graphql-tag'
import Home from 'App/Pages/Home'
import useState from 'App/hooks/useState'

export default function Redirect(props) {
  const [redirected, setRedirected] = useState(false)
  const {trackingDeliveryId} = props.match.params

  const {trackingDelivery} = useQuery({
    query: gql`
      query trackingDelivery($trackingDeliveryId: ID) {
        trackingDelivery(trackingDeliveryId: $trackingDeliveryId) {
          _id
          deepLink
        }
      }
    `,
    variables: {trackingDeliveryId}
  })

  if (trackingDelivery && !redirected) {
    window.location.replace(trackingDelivery.deepLink)
    setRedirected(true)
  }

  return <Home />
}
